module.exports = __webpack_public_path__ + "static/media/logo-bg.39417676.svg";